<div class="edit-workspace-container">
    <div class="button-container">
        <button class="cancel-btn" (click)="handleCancel()">
            <img src="assets/24x24/arrow-left-circle.svg" alt="">
            <span>Cancel</span>
        </button>
    </div>

    <div class="wrapper-container">
    <div *ngIf="loaderView">
        <app-loader></app-loader>
    </div>
    <div *ngIf="!loaderView">
    <ng-container *ngIf="form==='workspaceDetails'">
        <form [formGroup]="workspaceDetails">
                    <h2 class="section-title">Workspace Details</h2>
                    <div class="workspace-details-container">
                        <div class="workspace-info">
                            <div>
                                <p class="label">Workspace Name <span class="required-star">*</span></p>
                                <app-text-field placeholder="Enter Workspace name" type="text" name="name"
                                    formControlName="name"
                                    [value]="workspaceDetails.controls['name'].value"
                                    (change)="onInputChange('name',$event)"[hasError]="workspaceDetailsHasError('name')"></app-text-field>
                                    <small *ngIf="workspaceDetailsHasError('name')" class="error-message">Please enter a valid workspace name</small>
                            </div>
                        </div>
                        <div class="location-info">
                            <p class="label">Location(s) <span class="required-star">*</span></p>
                            <div class="subsection-container">
                                <ng-container *ngFor="let location of selectedLoactions">
                                    <div class="list-container">
                                        <div class="location-item">
                                            <p class="location-text"> {{ location }} </p>
                                        </div>
                                    </div>
                                </ng-container>
                                <button type="button" (click)="addControl('location')" class="add-btn">+ Add
                                    Location</button>
                            </div>
                        </div>
                        <div class="location-info">
                            <p class="label">Allowed Domain(s) <span class="required-star">*</span></p>
                            <div class="subsection-container">
                                <ng-container *ngFor="let domain of allowedDomains">
                                    <div class="list-container">
                                        <div class="location-item">
                                            <p class="location-text"> {{ domain }} </p>
                                        </div>
                                    </div>
                                </ng-container>
                                <button type="button" (click)="addControl('domain')" class="add-btn">+ Add
                                    Domain</button>
                            </div>
                        </div>
                        <div class="workspace-info">
                            <div>
                                <p class="label">Acronym Length <span class="required-star">*</span></p>
                                <app-text-field placeholder="Enter Acronym Length" type="number" name="acronymLength"
                                    formControlName="acronymLength"
                                    [value]="workspaceDetails.controls['acronymLength'].value"
                                    (change)="onInputChange('acronymLength',$event)"
                                    [hasError]="workspaceDetailsHasError('acronymLength')" [disabled]="true"></app-text-field>
                                <small *ngIf="workspaceDetailsHasError('acronymLength')" class="error-message">Please enter a valid acronym
                                    length</small>
                            </div>
                        </div>
                        <div class="location-info">
                            <p class="label">Acronym(s) <span class="required-star">*</span></p>
                            <p class="asset-code-info">You can add upto 1 acronym</p>
                            <div class="subsection-container">
                                <ng-container *ngFor="let acronym of selectedAcronyms">
                                    <div class="list-container">
                                        <div class="location-item">
                                            <p class="location-text"> {{ acronym }} </p>
                                        </div>
                                    </div>
                                </ng-container>
                                <button [ngClass]="{'disabled': canAddAcronym}"
                                    type="button" (click)="addControl('acronym')" class="add-btn"
                                    [disabled]="canAddAcronym">+ Add
                                    acronym</button>
                            </div>
                        </div>
                    </div>
                    <div class="company-details">
                <h2 class="section-title">Company Details</h2>
                <div class="company-info">
                    <div>
                        <p class="label">Company Name <span class="required-star">*</span></p>
                        <app-text-field placeholder="Enter company name" type="text" name="companyName"
                            formControlName="companyName" [value]="workspaceDetails.controls['companyName'].value"
                            (change)="onInputChange('companyName',$event)"[hasError]="workspaceDetailsHasError('companyName')"></app-text-field>
                            <small *ngIf="workspaceDetailsHasError('companyName')" class="error-message">Please enter a valid company name</small>
                    </div>
                    <div>
                        <p class="label">Company Website URL <span class="required-star">*</span></p>
                        <app-text-field placeholder="Enter website URL" type="url" name="companyWebsiteLink"
                            formControlName="companyWebsiteLink"
                            [value]="workspaceDetails.controls['companyWebsiteLink'].value"
                            (change)="onInputChange('companyWebsiteLink',$event)" [hasError]="workspaceDetailsHasError('companyWebsiteLink')"></app-text-field>
                            <small *ngIf="workspaceDetailsHasError('companyWebsiteLink')" class="error-message">Please enter a valid URL</small>
                    </div>
                    <div>
                        <p class="label">Date of Establishment <span class="required-star">*</span></p>
                        <app-text-field placeholder="Enter year" type="date" name="establishmentDate"
                            formControlName="establishmentDate"
                            [value]="workspaceDetails.controls['establishmentDate'].value"
                            (change)="onInputChange('establishmentDate',$event)" [max]="maxDate"
                            [hasError]="workspaceDetailsHasError('establishmentDate')"></app-text-field>
                             <small *ngIf="workspaceDetailsHasError('establishmentDate')" class="error-message">Please
                                enter a valid date</small>
                    </div>
                </div>
            </div>
            </form>
    </ng-container>
    <ng-container *ngIf="form==='userAttributes'">
                <h4>User Attributes & Values</h4>
                <div class="attributes-container">
                    <div class="attribute-info">
                        <div *ngFor="let category of assetDetails?.categories" class="card-container">
                            <div class="property-info">
                                <h3>{{ category.displayName}}<span class="required-star"> *</span></h3>
                                <div *ngFor="let config of groupedConfigs[category.name]; let configIndex = index"
                                    class="config-list">
                                    <div class=" config-item">
                                        <span class="values">
                                            <p class="values-heading">Value(s):</p>
                                            <span>
                                                {{ getValuesDisplay(config) }}
                                            </span>
                                        </span>
                                    </div>
                                    <button class="edit-button" (click)="onEditConfig(category.name, configIndex)">
                                        <img src="assets/14x14/edit_blue.svg" alt="Edit" class="edit-icon">
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </ng-container>
        <ng-container *ngIf="form==='workspaceOwnerDetails'">
            <form [formGroup]="workspaceOwnerDetails">
                <div *ngIf="!loaderView">
                    <h2 class="section-title">Workspace Owner Details</h2>
                    <div class="workspace-owner-details-container">
                        <div class="owner-info">
                            <div>
                                <p class="label">First Name <span class="required-star">*</span></p>
                                <app-text-field placeholder="Enter name" type="text" name="firstName"
                                    formControlName="firstName"
                                    [value]="workspaceOwnerDetails.controls['firstName'].value"
                                    (change)="onInputChange('firstName',$event)"
                                    [hasError]="workspaceOwnerHasError('firstName')"></app-text-field>
                                <small *ngIf="workspaceOwnerHasError('firstName')" class="error-message">Please enter a
                                    valid first name</small>
                            </div>
                            <div>
                                <p class="label">Last Name <span class="required-star">*</span></p>
                                <app-text-field placeholder="Enter name" type="text" name="lastName"
                                    formControlName="lastName"
                                    [value]="workspaceOwnerDetails.controls['lastName'].value"
                                    (change)="onInputChange('lastName',$event)"
                                    [hasError]="workspaceOwnerHasError('lastName')"></app-text-field>
                                <small *ngIf="workspaceOwnerHasError('lastName')" class="error-message">Please enter a
                                    valid last name</small>
                            </div>
                            <div>
                                <p class="label">Employee ID <span class="required-star">*</span></p>
                                <app-text-field placeholder="Enter employee ID" type="number" name="empId"
                                    formControlName="empId" [value]="workspaceOwnerDetails.controls['empId'].value"
                                    (change)="onInputChange('empId',$event)"
                                    [hasError]="workspaceOwnerHasError('empId')"></app-text-field>
                                <small *ngIf="workspaceOwnerHasError('empId')" class="error-message">Please enter a
                                    valid Employee ID</small>
                            </div>
                            <div>
                                <p class="label">Email <span class="required-star">*</span></p>
                                <app-text-field placeholder="Enter email address" type="email" name="email"
                                    formControlName="email" [value]="workspaceOwnerDetails.controls['email'].value"
                                    (change)="onInputChange('email',$event)"
                                    [hasError]="workspaceOwnerHasError('email')"
                                ></app-text-field>
                                <small *ngIf="workspaceOwnerHasError('email')" class="error-message">Please enter a
                                    valid email</small>
                            </div>
                            <div>
                                <p class="label">Phone <span class="required-star">*</span></p>
                                <app-text-field placeholder="Enter phone number" type="number" name="phoneNumber"
                                    formControlName="phoneNumber"
                                    [value]="workspaceOwnerDetails.controls['phoneNumber'].value"
                                    (change)="onInputChange('phoneNumber',$event)"
                                    [hasError]="workspaceOwnerHasError('phoneNumber')"></app-text-field>
                                <small *ngIf="workspaceOwnerHasError('phoneNumber')" class="error-message">Please enter
                                    a valid phone number</small>
                            </div>
                            <div>
                                <p class="label">Type <span class="required-star">*</span></p>
                                <app-generic-drop-down [options]="typeList" (value)="getIdOfType($event)"
                                    selectedValue="" [titleName]="'name'" [valueName]="'id'"
                                    [title]="selectedValue || 'Select Method'" [shouldEmitEmittedValue]="true" [createWorkspaceFlag]="true"></app-generic-drop-down>
                            </div>
                            <div>
                                <p class="label">Status <span class="required-star">*</span></p>
                                <app-generic-drop-down [options]="statusList" (value)="getIdOfStatus($event)"
                                    selectedValue="" [titleName]="'name'" [valueName]="'id'"
                                    [title]="selectedValue || 'Select Method'" [shouldEmitEmittedValue]="true" [createWorkspaceFlag]="true"></app-generic-drop-down>
                            </div>
                            <div>
                                <p class="label">Designation <span class="required-star">*</span></p>
                                <app-generic-drop-down [options]="designationList" (value)="getIdOfDesignation($event)"
                                    selectedValue="" [titleName]="'name'" [valueName]="'id'"
                                    [title]="selectedValue || 'Select Method'" [shouldEmitEmittedValue]="true"
                                    [createWorkspaceFlag]="true"></app-generic-drop-down>
                            </div>
                        </div>
                        <div class="owner-image-container">
                            <div class="image-upload-wrapper">
                                <div class="image-preview" (click)="fileInput.click()">
                                    <ng-container *ngIf="previewUrl; else placeholder">
                                        <img [src]="previewUrl" alt="Workspace Owner" />
                                    </ng-container>
                                    <ng-template #placeholder>
                                        <img src="assets/144x144/Profile-picture.svg" alt="Placeholder" />
                                    </ng-template>
                                </div>

                                <input type="file" #fileInput (change)="onFileSelected($event)" accept="image/*"
                                    hidden />

                                <div class="upload-link" (click)="fileInput.click()">
                                    <img src="assets/16x16/upload.svg" alt="Upload" />
                                    <span>Upload Workspace Owner’s Image</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </ng-container>
        <ng-container *ngIf="form==='plan'">
            <div>
                <h4>Plan Details</h4>
                <div class="plan-container">
                    <div class="plan-info">
                        <div>
                            <p class="label-form">Plan</p>
                            <app-generic-drop-down [options]="options" title="Select Plan" titleName="name"
                                valueName="id" [shouldEmitEmittedValue]="true"
                                (value)="handleValue($event)"></app-generic-drop-down>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    <div class="button-container">
        <app-button size="semi-large" theme="primary" (click)="handleUpdate()" [disabled]="getDisabledStatus()">{{buttonText}}</app-button>
    </div>
    </div>
</div>
</div>